<script setup lang="ts">
import { MenuButton } from "@headlessui/vue";
</script>

<template>
  <MenuButton class="dropdown-button">
    <slot></slot>
  </MenuButton>
</template>

<style lang="scss" scoped>
.dropdown-button {
  border: none;
  outline: inherit;
  background: none;
  color: inherit;
  font: inherit;
  appearance: none;
  cursor: pointer;
  padding: 0;
}
</style>
